import { Component, Input } from '@angular/core';
import { ControlValueAccessorModel, getProvider } from '../../models/control-value-accessor.model';
import { ActionKeys } from '../../enums/keys.enum';
import { SwithTypesEnum } from '../../enums/switch-types.enum';

/**
 * ### Accessibility Usage
 * + ***ariaDescribedBy*** - use this if the button has an external error message, or it needs extra description for screen reader. Use message's id
 * + ***ariaLabel*** - use this to provide an accessible label for the input
 * + ***initiallyFocusable*** - use this if the focusablity of the switch can vary and an initial state is needed. Usually used in a table and set to false
 */
@Component({
    selector: 'agpr-social-switch',
    templateUrl: './social-switch.component.html',
    styleUrls: ['./social-switch.component.scss'],
    providers: [getProvider(SocialSwitchComponent)],
    standalone: false
})
export class SocialSwitchComponent extends ControlValueAccessorModel<boolean> {
    @Input() onText: string;
    @Input() offText: string;
    @Input() disabled: boolean;
    @Input() tooltip: string;
    @Input() iconTooltip: string;
    @Input() ariaLabel: string;
    @Input() isArchiveSearch: boolean;
    @Input() initiallyFocusable: boolean = true;
    @Input() id: string;
    @Input() ariaDescribedBy: string;
    @Input() padding = 5;
    @Input() stopPropagation: boolean = true;
    @Input() style: SwithTypesEnum = SwithTypesEnum.primary;

    constructor() {
        super();
    }

    click(event: any ) {
        if (this.stopPropagation) {
            event.stopPropagation();
        }
        if (!this.disabled) {
            this.value = !this.value;
            this.onModelChange(this.value);
        }
    }

    writeValue(value: boolean): void {
        this.value = value;
    }

    onKeydown(event: KeyboardEvent) {
        if (event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE) {
            event.preventDefault();
            this.click(event);
        }
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }
}
